import { render, staticRenderFns } from "./inputBeratKering.vue?vue&type=template&id=de30bb78&"
import script from "./inputBeratKering.vue?vue&type=script&lang=js&"
export * from "./inputBeratKering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports